const maxHeaderFieldLength = {
  Description: 100,
  BatchName: 300,
  Purpose: 100
};

function illegalCharacters(keyName: string, str: string) {
  if (str.match(/[<>!@#$%^&*,]+/i)) {
    return `${keyName} must not contain <,>,!,@,#,$,%,^,&,* or comma (,).`;
  }
  return "";
}
function requiredOrMaxLength(keyName: string, str: string) {
  const keyNoSpaces = keyName.replace(/ /g, "") as keyof typeof maxHeaderFieldLength;
  const maxLength = maxHeaderFieldLength[keyNoSpaces];
  if (!str) {
    return `${keyName} is required (Max Length: ${maxLength} Characters).`;
  }
  if (str.length > maxLength) {
    return `${keyName} Max Length is ${maxLength} Characters.`;
  }
  return "";
}
export function getDescriptionErrorMessage(description: string): undefined | string {
  const nullOrSuperSizedStr = requiredOrMaxLength("Description", description);
  if (nullOrSuperSizedStr !== "") {
    return nullOrSuperSizedStr;
  }
  const illegalCharactersStr = illegalCharacters("Description", description);
  if (illegalCharactersStr !== "") {
    return illegalCharactersStr;
  }
  return undefined;
}
export function getBatchNameErrorMessage(batchName: string): undefined | string {
  const nullOrSuperSizedStr = requiredOrMaxLength("Batch Name", batchName);
  if (nullOrSuperSizedStr !== "") {
    return nullOrSuperSizedStr;
  }
  const illegalCharactersStr = illegalCharacters("Batch Name", batchName);
  if (illegalCharactersStr !== "") {
    return illegalCharactersStr;
  }
  return undefined;
}
export function getPurposeErrorMessage(purpose: string): undefined | string {
  const nullOrSuperSizedStr = requiredOrMaxLength("Purpose", purpose);
  if (nullOrSuperSizedStr !== "") {
    return nullOrSuperSizedStr;
  }
  const illegalCharactersStr = illegalCharacters("Purpose", purpose);
  if (illegalCharactersStr !== "") {
    return illegalCharactersStr;
  }
  return undefined;
}
